import { createContext } from 'react';
import type { ApiClient } from '@instanexus/sdk';

/**
 * The typed SDK client, injected rather than imported as a singleton.
 *
 * The app never calls `fetch` (docs/009) — every read goes through a resource on
 * this client. Injection is what lets a component test swap in a fake at the SDK
 * boundary instead of stubbing the network.
 *
 * `null` is the "no provider" sentinel; `useApiClient()` turns it into a throw.
 */
export const ApiClientContext = createContext<ApiClient | null>(null);
